import React, { useState, useEffect } from 'react';
import UserIcon from 'assets/icon/UserIcon';
import SettingIcon from 'assets/icon/SettingIcon';
import DashboardIcon from 'assets/icon/DashboardIcon';
import CreditCardIcon from 'assets/icon/CreditCardIcon';
import GroupIcon from 'assets/icon/GroupIcon';
import TableIcon from 'assets/icon/TableIcon';
import CalculatorIcon from 'assets/icon/CalculatorIcon';
import LineChartIcon from 'assets/icon/LineChartIcon';
import MoneyIcon from 'assets/icon/MoneyIcon';
import PinLocationIcon from 'assets/icon/PinLocationIcon';
import BankIcon from 'assets/icon/BankIcon';
import TransferIcon from 'assets/icon/TransferIcon';
import MoneyWithdrawIcon from 'assets/icon/MoneyWithdrawIcon';
import { SidebarMenuButton } from 'components/Cards';
import CurrencyNotes from 'assets/icon/CurrencyNotes';
import { useVariable } from 'utils/context/VariableContext';

export default function Sidebar({ isOpen, onSidebarClick }) {
	const { isAdmin } = useVariable()

	const iconSize = 'w-5'
  
	return (
		<div className={`fixed sm:relative h-screen bg-white shadow-md transition-all z-20 text-sm
			${ isOpen ? 'w-full sm:w-60' : 'hidden sm:block sm:w-20' }`}
		>
			<div className={`h-screen flex flex-col items-center gap-6 lg:text-base py-4 w-full`}>
				<div className="items-start flex flex-col w-full gap-2 px-2 overflow-y-auto mb-24 sm:mb-12 ">
					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={isAdmin}
						title='Dashboard'
						href="/dashboard"
					>
						<DashboardIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Transaction'
						href="/"
					>
						<CalculatorIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Transfer'
						href="/transfer"
					>
						<TransferIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Pelunasan'
						href="/pelunasan"
					>
						<CalculatorIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Pelanggan'
						href="/customer"
					>
						<GroupIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Kartu Pelanggan'
						href="/customer-card"
					>
						<CreditCardIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Laporan'
						href="/transaction-report"
					>
						<TableIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={isAdmin}
						title='Laporan SV EDC'
						href="/daily-transaction-report"
					>
						<TableIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={isAdmin}
						title='Payment'
						href="/payment-received"
					>
						<MoneyIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={isAdmin}
						title='Statistic Report'
						href="/statistic-report"
					>
						<LineChartIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Beneficiary Account'
						href="/beneficiary-account"
					>
						<BankIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={isAdmin}
						title='Pengeluaran'
						href="/expense"
					>
						<CurrencyNotes className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<div className={`${ isOpen ? 'hidden sm:flex gap-2' : 'hidden' }`}>
						<span className='text-gray-300 text-sm'>Human Resource</span>
						<div className='h-1 bg-gray-300' />
					</div>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={isAdmin}
						title='Employee'
						href="/hr/employee"
					>
						<UserIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={isAdmin}
						title='Payroll'
						href="/hr/payroll"
					>
						<MoneyIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<div className={`${ isOpen ? 'hidden sm:block' : 'hidden' }`}>
						<span>Setting</span>
					</div>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={isAdmin}
						title='Setting'
						href="/setting"
					>
						<SettingIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>
				</div>
			</div>
		</div>
  	)
}
